import styled, { css } from 'styled-components';
import { Colors, Media } from 'enums';

export const Container = styled.label<{ removeGap?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  max-width: max-content;
  align-items: center;
  line-height: 24px;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  cursor: pointer;

  :after {
    content: '';
    position: absolute;
    left: -5%;
    width: 100%;
    height: 100%;
    padding: 5%;
  }

  ${({ removeGap }) =>
    !removeGap &&
    css`
      column-gap: 8px;
      @media ${Media.notebook} {
        column-gap: 18px;
      }
    `}
`;

export const CheckBoxInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
  opacity: 0;
`;

export const CheckMark = styled.span<{ isVisible: boolean }>`
  position: relative;
  box-sizing: border-box;
  height: 20px;
  width: 20px;
  border-radius: 4px;

  ${({ isVisible }) => {
    if (isVisible) {
      return css`
        background-color: ${Colors.yellow1};
        border: none;
      `;
    }
    return css`
      background-color: ${Colors.white};
      border: 1px solid ${Colors.gray3};
    `;
  }}

  :after {
    content: '';
    position: absolute;
    display: none;
    left: 8px;
    top: 4px;
    width: 4px;
    height: 9px;
    border: solid white;
    border-width: 0 1px 1px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);

    ${({ isVisible }) =>
      isVisible &&
      css`
        display: block;
        border-color: ${Colors.gray1};
      `}

    @media ${Media.notebook} {
      left: 9px;
      top: 5px;
      width: 5px;
      height: 10px;
    }
  }

  @media ${Media.notebook} {
    height: 24px;
    width: 24px;
  }
`;
